import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { canManageCourierRounds } from "../../utils/helper";
import CourierListPage, { CourierListHeadAction } from "./courier-list-page";
import CreateScheduleForm from "./forms/create-schedule-form";
import Confirmation from "../commons/confirmation";
import CourierTable from "./ui/courier-table";
import CourierBooleanTag from "./ui/courier-boolean-tag";
import RowActions from "./ui/row-actions";
import { useCourierMutationDone } from "./ui/use-courier-mutation-done";

const RoundSchedulesList = props => {
  const {
    getCourierRoundSchedules,
    roundSchedules = [],
    courierLoading,
    createCourierRoundSchedule,
    deleteCourierRoundSchedule,
    getCourierRounds,
    rounds = [],
    getCouriers,
    couriers = [],
    resetCourierState,
    courierApiError
  } = props;

  const [isOpenCreateModal, setIsOpenCreateModal] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const canManage = canManageCourierRounds();

  useCourierMutationDone(courierLoading, courierApiError, () => {
    setIsOpenCreateModal(false);
  });

  useEffect(() => {
    getCourierRoundSchedules({});
    getCourierRounds && getCourierRounds({});
    getCouriers && getCouriers({});
    return () => {
      resetCourierState();
    };
  }, []);

  return (
    <CourierListPage
      title="Courier Schedules"
      count={roundSchedules.length}
      loading={courierLoading}
      headActions={
        canManage && (
          <CourierListHeadAction
            label="Add Schedule"
            onClick={() => setIsOpenCreateModal(true)}
          />
        )
      }
    >
      <CourierTable>
        <thead>
          <tr>
            <th>Round</th>
            <th>Weekday</th>
            <th>Start Time</th>
            <th>Default Courier</th>
            <th className="status">Active</th>
            {canManage && <th className="act">Actions</th>}
          </tr>
        </thead>
        <tbody>
          {roundSchedules.map(s => (
            <tr key={s.id}>
              <td>
                {s.roundCode}
                <span className="sm-text">ID {s.id}</span>
              </td>
              <td>{s.weekdayDisplay}</td>
              <td>{s.startTime}</td>
              <td>{s.defaultCourierName || "—"}</td>
              <td className="status">
                <CourierBooleanTag value={s.isActive} />
              </td>
              {canManage && (
                <td className="act">
                  <RowActions onDelete={() => setDeleteTarget(s)} />
                </td>
              )}
            </tr>
          ))}
          {!roundSchedules.length && !courierLoading && (
            <tr>
              <td colSpan={canManage ? 6 : 5}>No schedules found.</td>
            </tr>
          )}
        </tbody>
      </CourierTable>

      {isOpenCreateModal && (
        <Modal
          isOpen={isOpenCreateModal}
          onRequestClose={() => setIsOpenCreateModal(false)}
          className="small-modal"
        >
          <CreateScheduleForm
            closeModal={() => setIsOpenCreateModal(false)}
            loading={courierLoading}
            apiError={courierApiError}
            rounds={rounds}
            couriers={couriers}
            createCourierRoundSchedule={createCourierRoundSchedule}
          />
        </Modal>
      )}

      {deleteTarget && (
        <Modal
          isOpen={!!deleteTarget}
          onRequestClose={() => setDeleteTarget(null)}
          className="small-modal"
        >
          <Confirmation
            text={`Delete schedule for ${deleteTarget.roundCode} (${deleteTarget.weekdayDisplay})?`}
            onConfirm={() => {
              deleteCourierRoundSchedule(deleteTarget.id);
              setDeleteTarget(null);
            }}
            onClose={() => setDeleteTarget(null)}
          />
        </Modal>
      )}
    </CourierListPage>
  );
};

export default RoundSchedulesList;
